import { create } from 'zustand';
import { SystemAlertData } from '../dto/EntityRepository';

interface SystemAlertState {
  systemAlertList: SystemAlertData[];
  setSystemAlertList: (value: SystemAlertData[]) => void;
}

export const useSystemAlertStore = create<SystemAlertState>((set) => ({
  systemAlertList: [],
  setSystemAlertList: (systemAlertList) => set({ systemAlertList })
}));